import { render, staticRenderFns } from "./SwitchShop.vue?vue&type=template&id=453d7256&scoped=true"
import script from "./SwitchShop.vue?vue&type=script&lang=js"
export * from "./SwitchShop.vue?vue&type=script&lang=js"
import style0 from "./SwitchShop.vue?vue&type=style&index=0&id=453d7256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d7256",
  null
  
)

export default component.exports